import { Controller } from "@hotwired/stimulus"

// The on-call layer form's "Repeats" picker (organizations/on_call_schedules/_layers.html.erb):
// shows only the fields the chosen option uses. Every day and Weekly use a first day and a
// handoff time (Weekly also its days); Custom uses a raw RRULE and a first shift instead. Purely
// cosmetic: the server decides from the chosen option alone (see
// OnCallScheduleLayer#apply_recurrence_picker), so without JS every field shows and still works.
export default class extends Controller {
  static targets = ["weekly", "picker", "custom"]

  connect() {
    this.update()
  }

  update() {
    const checked = this.element.querySelector("input[type=radio]:checked")
    const repeat = checked ? checked.value : "weekly"

    this.weeklyTarget.hidden = repeat !== "weekly"
    this.pickerTarget.hidden = repeat === "custom"
    this.customTarget.hidden = repeat !== "custom"
  }
}
